import { render } from "./CarSlider.vue?vue&type=template&id=48de4783"
import script from "./CarSlider.vue?vue&type=script&lang=js"
export * from "./CarSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__